import ApiService from '../../../services/apiService';
import userListMixin from '@/components/core/tenant/userListMixin';
import { copyToClipboard } from '@/utils/vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreTenantApiKeyList',
  mixins: [userListMixin],
  props: {
    tenantId: {
      type: Number,
      required: true
    },
    tenantDetails: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    isApiKeysVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      apiKeyEditDialog: false,
      isCreatingApiKey: false,
      editFormValidity: false,
      loadAccessOverlay: false,
      apiKeyModel: {},
      originalModel: {},
      apiKeyList: this.userList,
      requiredRule: [v => !!v || this.$i18n_t('Common.fieldRequired')]
    };
  },
  computed: {
    fetchOptions() {
      return ['apikeys', 'no-rules'];
    },
    tableLocalized() {
      return {
        headers: [{
          sortable: true,
          text: this.$i18n_t('accMgmt.user.apiKey.token'),
          value: 'email' // cannot sort by ID, but the email is set to the ID for api-keys
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.user.apiKey.title'),
          value: 'username'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.user.apiKey.limit'),
          value: 'properties.apiLimit'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.user.apiKey.validUntil'),
          value: 'properties.apiValidityDate'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.active'),
          value: 'active'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.actions'),
          value: '',
          align: 'right'
        }]
      };
    }
  },
  async created() {
    this.fetchUsers();
  },
  methods: {
    copyToClipboard: copyToClipboard,
    toggleHideApiKeys() {
      this.isHideApiKeys = !this.isHideApiKeys;
    },
    addApiKey() {
      const oneYearInFuture = new Date(new Date() - -86400 * 365 * 1000);
      this.apiKeyModel = {
        active: true,
        access: [],
        properties: {
          apiLimit: 50,
          apiValidityDate: oneYearInFuture
        }
      };
      this.apiKeyEditDialog = true;
    },
    editApiKey(apiKey) {
      this.apiKeyModel = cloneDeep(apiKey);
      this.originalModel = cloneDeep(apiKey);
      this.apiKeyEditDialog = true;
      this.loadAccessOverlay = true;
      ApiService.getUser(this, apiKey.id).then(res => {
        this.apiKeyModel.access = cloneDeep(res.access);
        this.originalModel.access = cloneDeep(res.access);
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.loadAccessOverlay = false;
      });
    },
    didSelectScope(scope) {
      this.apiKeyModel.scope = scope;
      this.apiKeyModel = cloneDeep(this.apiKeyModel);
      this.fetchDefaultRoles(scope.id);
    },
    fetchDefaultRoles(scopeId) {
      ApiService.fetchDefaultRoles(scopeId).then(roles => {
        if (roles.length > 0) {
          this.apiKeyModel.access = [{
            tenantId: roles[0].tenantId,
            scopeId: scopeId,
            Scope: {
              id: scopeId
            },
            roles,
            primary: true
          }];
        }
      }).catch(() => {
        this.$snack(this.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
      });
    },
    dateTimeChange(dateObject) {
      this.apiKeyModel.properties.apiValidityDate = dateObject.from * 1000;
    },
    updatedUserAccess(access) {
      this.apiKeyModel.access = access;
      if ((access || []).length === 0) {
        delete this.apiKeyModel.scope;
      }
    },
    handleSubmit() {
      if (this.apiKeyModel.properties.apiValidityDate) {
        this.apiKeyModel.properties.apiValidityDate = new Date(this.apiKeyModel.properties.apiValidityDate).toISOString();
      }
      this.isCreatingApiKey = true;
      let promise = null;
      if (this.apiKeyModel.id) {
        promise = this.updateApiKey(this.apiKeyModel);
      } else {
        promise = this.createApiKey(this.apiKeyModel);
      }
      promise.catch(error => {
        console.error(error);
      }).finally(() => {
        // reset request-option to make sure the table(page) is reloaded
        this.priorRequestOptions = null;
        this.isCreatingApiKey = false;
        this.fetchUsers();
      });
    },
    createApiKey(apiKey) {
      return ApiService.createApiUser(this.sessionPrimaryTenantIds[0], apiKey).then(() => {
        this.apiKeyEditDialog = false;
        this.$snack(this.$i18n_t('accMgmt.user.apiKey.createSuccessSnack'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.user.apiKey.createFailedSnack'), 'error');
        }
      });
    },
    updateApiKey(apiKey) {
      return ApiService.updateUser(apiKey).then(() => {
        return ApiService.updateUserAccess(apiKey, this.originalModel);
      }).then(() => {
        this.apiKeyEditDialog = false;
        this.$snack(this.$i18n_t('accMgmt.user.apiKey.editSuccessSnack'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.user.apiKey.editFailedSnack'), 'error');
        }
        console.error('Error updating user access', error);
      });
    },
    close() {
      this.apiKeyEditDialog = false;
    }
  }
};